// ids in this file are used in multi places
import { defineMessages } from "react-intl"

export default defineMessages({
  login: {
    id: "app.site.login",
  },
  myProfile: {
    id: "app.site.myProfile",
  },
  required: {
    id: "app.site.required",
  },
  save: {
    id: "app.site.save",
  },
  saveAndNext: {
    id: "app.site.saveAndNext",
  },
  back: {
    id: "app.site.back",
  },
  cancel: {
    id: "app.site.cancel",
  },
  edit: {
    id: "app.site.edit",
  },
  delete: {
    id: "app.site.delete",
  },
  createProfile: {
    id: "app.site.createProfile"
  },
  selectMultiPlaceholder: {
    id: "app.site.selectMultiPlaceholder",
  },
  selectSinglePlaceholder: {
    id: "app.site.selectSinglePlaceholder",
  },
  completeProfile: {
    id: "app.site.completeProfile",
  },
  updateProfileSuccess: {
    id: "app.site.updateProfileSuccess",
  },
  updateProfileFail: {
    id: "app.site.updateProfileFail",
  },
  NO: {
    id: "app.site.no",
  },
  YES: {
    id: "app.site.yes",
  },
  NONE: {
    id: "app.site.none",
  },
  NAMobile: {
    id: "app.site.naMobile",
  },
  NASocialHabits: {
    id: "app.site.naSocialHabits",
  },
  NAAccessibilities: {
    id: "app.site.naAccessibilities",
  },
  TOAST_ERROR_MESSAGE: {
    id: "app.site.toastErrorMessage",
  },
  FIELD_REQUIRED: {
    id: "app.components.Yup.FIELD_REQUIRED",
  },
  FIELD_TOO_LONG: {
    id: "app.components.Yup.FIELD_TOO_LONG",
  },
  FIELD_TOO_SHORT: {
    id: "app.components.Yup.FIELD_TOO_SHORT",
  },
  TOO_MANY_VALUES: {
    id: "app.components.Yup.TOO_MANY_VALUES",
  },
  FIELD_INVALID: {
    id: "app.components.Yup.FIELD_INVALID",
  },
  FIELD_INVALID_EMAIL: {
    id: "app.components.Yup.FIELD_INVALID_EMAIL",
  },
  FIELD_EXACT_NUMBER_OPTION: {
    id: "app.components.Yup.FIELD_EXACT_NUMBER_OPTION",
  },
  FIELD_AT_MOST_NUMBER_OPTION: {
    id: "app.components.Yup.FIELD_AT_MOST_NUMBER_OPTION",
  },
  ERROR_TITLE: {
    id: "app.components.ErrorCard.title",
  },
  ERROR_MESSAGE: {
    id: "app.components.ErrorCard.message",
  },
  ERROR_RELOAD: {
    id: "app.components.ErrorCard.reload",
  },
  ERROR_HOME: {
    id: "app.components.ErrorCard.home",
  },
  ERROR_CONTACT: {
    id: "app.components.ErrorCard.contact",
  },
  pictureLogo: {
    id: "app.assets.picture.home.logo"
  },
  pictureUser: {
    id: "app.assets.picture.home.user"
  },
  iconWarning: {
    id: "app.assets.icon.warning"
  },
  step: {
    id: "app.site.step",
    defaultMessage: "Step",
  },
  optional: {
    id: "app.site.optional"
  },
})
